import { connect } from 'react-redux';
import { getFaveCount } from '../../../../../../CollectionPanel/redux/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        faveCount: getFaveCount(state, deviation),
    });
};
export default connect(mapStateToProps);
//# sourceMappingURL=FaveControl.container.js.map